module.exports = __webpack_public_path__ + "img/EQUAL.a03079eb.svg";